import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import IllustratedBlankSlate from 'modules/surveys/components/IllustratedBlankSlate'

import illustration from './illustration.svg'

const BlankSlate = () => (
  <IllustratedBlankSlate
    illustration={illustration}
    title={i18n.t('surveys.form.tabs.no_results.title')}
    description={i18n.t('surveys.form.tabs.no_results.survey_description')}
  />
)

export default BlankSlate
